var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 9.16667,
    rx: 2,
    fill: "#24316F",
    style: {
      transition: "all 0.3s ease-in-out"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.16667,
    height: 9.16667,
    rx: 2,
    fill: "#6E81CB",
    style: {
      transition: "all 0.3s ease-in-out"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.833,
    width: 20,
    height: 9.16667,
    rx: 2,
    fill: "#24316F",
    style: {
      transition: "all 0.3s ease-in-out"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.833,
    y: 10.833,
    width: 9.16667,
    height: 9.16667,
    rx: 2,
    fill: "#6E81CB",
    style: {
      transition: "all 0.3s ease-in-out"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.424dca684c22b7843b3557491bb67a15.svg";
export { ForwardRef as ReactComponent };